import APIClient from '../factories/APIClient'

// import attachMock from '../factories/attachMock'
// import MOCK_RESPONSES from './Mall.mock.json'

const client = new APIClient({
  baseURL: process.env.REACT_APP_EXPLORE_API_BASE_URL,
})

// if (process.env.NODE_ENV === 'development') {
//   attachMock(
//     client,
//     MOCK_RESPONSES,
//   )({
//     // 'get /cms/malls': 200,
//     // 'get /malls': 200,
//     // 'get /malls/*': 200,
//   })
// }

export function getTnCContent() {
  return client({
    method: 'get',
    url: '/user-agreement-content/tnc',
  })
}

export function getPNContent() {
  return client({
    method: 'get',
    url: '/user-agreement-content/pn',
  })
}
